resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';/*
    YouTube

    Wrapper class for YouTube API.
 */
function YouTube(divId, videoId, autoplay, playerVars) {

    // Parameters

    // Properties
    this.player = null;
    this.autoplay = false;

    this._divId = null;
    this._videoId = null;
    this._playerVars = null;
    this._initialized = false;

    this.constructor = function(divId, videoId, autoplay, playerVars) {
        this._divId = divId;
        this._videoId = videoId;
        this._playerVars = playerVars;

        if (autoplay != null)
            this.autoplay = autoplay;

        if (mogo.registry.mogoUI.repo.ytQueued === undefined) {
            mogo.registry.mogoUI.repo.ytQueued = [];
        }
        // Get Youtube API
        if (window.YT == undefined) {
            mogo.registry.mogoUI.repo.ytQueued.push(this);

            var tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            window.onYouTubeIframeAPIReady = this._onYouTubeIframeAPIReady;
        } else if (window.YT.loaded !== 1) {
            window.onYouTubeIframeAPIReady = this._onYouTubeIframeAPIReady;
        } else {
            this._createPlayer();
        }
        this._loadDeferredVideo();
    };

    this.play = function() {
        if (this._initialized && this._videoId != null)
            this.player.playVideo();
    };

    this.stop = function() {
        if (this._initialized && this._videoId != null)
            this.player.stopVideo();
    };

    this.pause = function() {
        if (this._initialized && this._videoId != null)
            this.player.pauseVideo();
    };

    this.load = function(vidId, playImmediately) {
        this._videoId = vidId;
        if (this.player != null) {
            if (playImmediately)
                this.player.loadVideoById(vidId);
            else
                this.player.cueVideoById(vidId);
        } else {
            if (playImmediately)
                this.autoplay = true;
            this._createPlayer();
        }
    };

    // to lazy load a embeded video, user `data-defer-video` for the video url instead of `src` attribute (e.g. <iframe data-defer-video='https://www.youtube.com/embed/xxx'>)
    this._loadDeferredVideo = function () {
      var defVidEl = document.getElementById(this._divId);
      if (defVidEl && defVidEl.getAttribute('data-defer-video')) {
        defVidEl.setAttribute('src', defVidEl.getAttribute('data-defer-video'));
      }
    };

    this._onYouTubeIframeAPIReady = function() {
        while (mogo.registry.mogoUI.repo.ytQueued.length > 0) {
            var inst = mogo.registry.mogoUI.repo.ytQueued.shift();
            inst._createPlayer();
        }
    };

    this._createPlayer = function() {
        if (this._videoId != null) {
            this.player = new YT.Player(this._divId, {
                videoId: this._videoId,
                height: "100%",
                width: "100%",
                enablejsapi: 1, // enable the player to be controlled via the API.
                events: {
                    'onReady': $.proxy(this._onPlayerReady, this)
                },
                playerVars: this._playerVars
            });
        }
    };

    this._onPlayerReady = function() {
        this._initialized = true;

        if (this.autoplay) {
            this.player.playVideo();
        }
    };

    this.constructor(divId, videoId, autoplay, playerVars);
}
